import { lazy } from "react";

const edit = lazy(() => import("./Edit").then(m => ({ default: m.PerformancePrivateEdit })));

export default { edit };
